import { Box } from "@mui/material";
import { DotLegalLink } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import TopBarTile from "./TopBarTile";
import { useTopBarTileStyles } from "./TopBarTile.styles";

export interface ITopBarNumberTileProps {
    label: string;
    isLoading?: boolean;
    // A count (locale-formatted) or an already-formatted value such as an interval ("1-9") shown with the same standalone-number styling.
    value: number | string | undefined;
    total?: number;
    onClick?: () => void;
}

function TopBarNumberTile(props: ITopBarNumberTileProps) {
    const { translateNumber } = useTranslation();
    const styles = useTopBarTileStyles();

    const format = (value: number | string | undefined) => (typeof value === "number" ? translateNumber(value) : (value ?? ""));
    const content = props.total !== undefined ? `${format(props.value)}/${translateNumber(props.total)}` : format(props.value);

    const number = props.onClick ? (
        <Box sx={{ display: "flex", justifyContent: "center" }}>
            <DotLegalLink linkColor="primary" onClick={props.onClick}>
                <Box component="span" sx={styles.linkValue}>
                    {content}
                </Box>
            </DotLegalLink>
        </Box>
    ) : (
        <Box sx={styles.value}>{content}</Box>
    );

    return (
        <TopBarTile label={props.label} isLoading={props.isLoading}>
            {number}
        </TopBarTile>
    );
}

export default TopBarNumberTile;
